<template>
</template>
<script>
    import PreviewElement from "./PreviewElement";
    import TextElement from "../../components/pagesbuilder/elements/TextElement";

    export default {
        name: "PreviewTextElement",
        mixins: [PreviewElement,TextElement]
    }
</script>
